// src/utils/models/switchCalendarModel.js

export const createSwitchCalendarEvent = (data) => ({
  id: data.id || '',
  switchId: data.switchId || '',
  switchClientId: data.switchClientId || '',
  switchClientName: data.switchClientName || '',
  supplierId: data.supplierId || '',
  supplierName: data.supplierName || '',
  fechaEntrada: data.fechaEntrada || '',
  fechaAlerta: data.fechaAlerta || '', // Un mes antes de cumplir el año
  fechaAniversario: data.fechaAniversario || '', // Exactamente un año después
  completado: data.completado || false,
  fechaCompletado: data.fechaCompletado || '',
  notas: data.notas || '',
  createdAt: data.createdAt || new Date().toISOString(),
  updatedAt: data.updatedAt || new Date().toISOString(),
  isActive: true
});